// Copyright (c) StrangeBee 2023

import client from '@Client';
import { useLocalMessage } from '@Helpers/locale';
import { handleNotificationError, openMessage } from '@Helpers/notification';
import { computeEventList } from '@Organisms/AccountDetails/eventList';
import { LoginPasswordChange } from '@Organisms/Login/LoginPasswordChange/LoginPasswordChange';
import { LoginSider } from '@Organisms/Login/LoginSider/LoginSider';
import { useGenericQuery } from '@Queries/genericQueries';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import { Layout } from 'antd';
import React, { useMemo, ReactElement, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { BrandingParams } from 'thehive-sdk';

const ChangePassword = (): ReactElement => {
    const i = useLocalMessage();
    const { secret } = useParams<{ secret: string }>();
    const { data: brandingData } = useGenericQuery<BrandingParams>({
        fetchOnStart: true,
        manual: true,
        retry: false,
        key: ['branding-props'],
        fetchCallback: useCallback(() => client.BrandingController.list(), []),
    });

    const eventList = useMemo(
        () =>
            computeEventList({
                controller: client.AuthController,
                onSuccess: (count, message) => {
                    if (message) {
                        openMessage('success', message);
                    }
                },
                onError: handleNotificationError,
                locale: i,
            }),
        [i],
    );

    return (
        <Layout className="login-layout" key="login">
            <LoginSider src={brandingData?.loginLogo} />
            <LoginPasswordChange eventList={eventList} secret={secret} />
        </Layout>
    );
};

export const Route: RouteType = {
    path: RouteBuilder.compute('login.change'),
    content: <ChangePassword />,
    exact: true,
};
